import React from 'react';
import { Link, useParams } from 'react-router-dom';

import { taskImportRunsApiClient } from '../../services/api/taskImportRunsService';

export const TaskImportRunMatterTasks: React.FC = () => {
  const { runId, matterLinkId } = useParams<{
    runId: string;
    matterLinkId: string;
  }>();
  const { data, isFetching } =
    taskImportRunsApiClient.useTaskImportRunsTaskLinksForMatterQuery(
      { id: runId as string, matterLinkId: matterLinkId as string },
      { skip: !runId || !matterLinkId },
    );

  return (
    <div className="p-4">
      <div className="mb-3 flex items-center justify-between">
        <h1 className="text-lg font-semibold">Tasks for Matter Link</h1>
        <Link
          className="text-sm text-blue-700 hover:underline"
          to={`/profile/external-cms/runs/${runId}`}
        >
          Back to run
        </Link>
      </div>

      {isFetching ? (
        <div className="text-sm text-gray-600">Loading…</div>
      ) : !data || data.length === 0 ? (
        <div className="text-sm text-gray-600">No tasks.</div>
      ) : (
        <div className="overflow-x-auto">
          <table className="min-w-full text-left text-sm">
            <thead className="text-xs uppercase text-gray-500">
              <tr>
                <th className="px-2 py-2">Task</th>
                <th className="px-2 py-2">Matched</th>
                <th className="px-2 py-2">Confidence</th>
                <th className="px-2 py-2">Reasoning</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-gray-100">
              {data.map((t) => (
                <tr key={String(t.id)}>
                  <td className="px-2 py-2">
                    {t.task_facets.task_name ?? '(unnamed)'}
                  </td>
                  <td className="px-2 py-2">{t.task_id ? 'Yes' : 'No'}</td>
                  <td className="px-2 py-2">
                    {t.link_result.confidence.toFixed(2)}
                  </td>
                  <td className="px-2 py-2 max-w-xl">
                    {t.link_result.reasoning}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};
